// Copyright © 2021 Move Closer
/**
 * Focus directive for fields
 */
export default {
    bind(el, binding) {
        if (binding.value === true) {
            setTimeout(() => el.focus(), 0);
        }
    },
    update(el, binding) {
        if (binding.value === true) {
            setTimeout(() => el.focus(), 0);
        }
    }
};
